// Copied from https://www.npmjs.com/package/memoize-one
// This package's flowTypes were breaking complilation and I couldn't figure out why
// so just copied over into this location

const simpleIsEqual = (a, b) => a === b;

export default (resultFn, isEqual = simpleIsEqual) => {
    let lastThis;
    let lastArgs = [];
    let lastResult;
    let calledOnce = false;

    const isNewArgEqualToLast = (newArg, index) => isEqual(newArg, lastArgs[index]);

    // breaking cache when context (this) or arguments change
    return (...newArgs) => {
        if (
            calledOnce &&
            lastThis === this &&
            newArgs.length === lastArgs.length &&
            newArgs.every(isNewArgEqualToLast)
        ) {
            return lastResult;
        }

        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        lastResult = resultFn.apply(this, newArgs);
        return lastResult;
    };
};
